declare global {
  interface Window {
    kakao: any;
  }
}

class MapService {
  private map: any = null;
  private marker: any = null;
  private infowindow: any = null;

  initMap(container: HTMLElement, lat: number, lng: number, title: string) {
    const { kakao } = window;
    if (!kakao || !kakao.maps) return;

    const options = {
      center: new kakao.maps.LatLng(lat, lng),
      level: 3,
    };

    this.map = new kakao.maps.Map(container, options);
    this.addMarker(lat, lng, title);
  }

  initWithAddress(container: HTMLElement, address: string, title: string) {
    const { kakao } = window;
    if (!kakao || !kakao.maps || !kakao.maps.services) return;

    const geocoder = new kakao.maps.services.Geocoder();

    geocoder.addressSearch(address, (result: any, status: any) => {
      if (status === kakao.maps.services.Status.OK) {
        const coords = new kakao.maps.LatLng(result[0].y, result[0].x);

        const options = {
          center: coords,
          level: 3,
        };

        this.map = new kakao.maps.Map(container, options);
        this.addMarker(result[0].y, result[0].x, title);

        // 지도의 중심을 마커로 이동
        this.map.setCenter(coords);
      }
    });
  }

  private addMarker(lat: number, lng: number, title: string) {
    const { kakao } = window;
    const markerPosition = new kakao.maps.LatLng(lat, lng);

    this.marker = new kakao.maps.Marker({
      position: markerPosition,
    });
    this.marker.setMap(this.map);

    const iwContent = `<div style="padding:10px; font-size:14px; font-weight:700; color:#004094; min-width:150px; text-align:center;">${title}</div>`;
    this.infowindow = new kakao.maps.InfoWindow({
      content: iwContent,
    });
    this.infowindow.open(this.map, this.marker);
  }

  relayout() {
    if (this.map) {
      this.map.relayout();
    }
  }

  setCenter(lat: number, lng: number) {
    if (this.map && window.kakao) {
      const moveLatLon = new window.kakao.maps.LatLng(lat, lng);
      this.map.setCenter(moveLatLon);
    }
  }
}

export const mapService = new MapService();
